module.exports = __webpack_public_path__ + "img/osm-icon.18147643.png";